import * as z from "zod";

export const updateConsolidationViewFolder = {
  name: "updateConsolidationViewFolder" as const,
  input: z.object({ folderId: z.string(), name: z.string() }),
  output: z.object({}),
};
